import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { Competencies } from '../components/Competencies';
import { SectionNav } from '../components/SectionNav';
const READINESS = [{
  title: 'Financial Expert Designation',
  body: 'Qualifies as an audit committee financial expert: an active CPA with direct responsibility for preparing, auditing, and evaluating financial statements of large regulated institutions.'
}, {
  title: 'Regulatory Fluency',
  body: 'First-hand experience of Federal Reserve, OCC, and SEC supervisory processes — including examination management and the closure of formal supervisory findings.'
}, {
  title: 'Independence & Availability',
  body: 'Seeking independent director mandates with the availability and preparation discipline expected of a committee chair or member.'
}];
export function BoardCompetencies() {
  return <>
      <PageHeader index="06" title="Strategic Value Proposition & Board Competencies" intro="What Gerry contributes in the boardroom: three competency pillars, and the readiness credentials behind each of them." data-id="element-330" data-mp="1qekowx3sl4q1" />
      <Competencies data-id="element-331" data-mp="37mdxocaad2wg" />

      <section aria-labelledby="readiness" className="w-full bg-white" data-id="element-332" data-mp="3lfvis1imenol">
        <div className="mx-auto max-w-content px-6 py-20 sm:py-24 lg:px-8" data-id="element-333" data-mp="3lh6nq4nsy1ha">
          <h2 id="readiness" className="text-[11px] font-semibold uppercase tracking-widest text-navy-700" data-id="element-334" data-mp="3godi7ekiep45">
            Board Readiness Statement
          </h2>
          <div className="mt-10 grid grid-cols-1 gap-px border border-slateink-300/70 bg-slateink-300/70 lg:grid-cols-3" data-id="element-335" data-mp="3qe6pw4hj6k34">
            {READINESS.map(item => <article key={item.title} className="bg-white p-8" data-id="element-336" data-mp="481jlxe37ly3">
                <h3 className="font-serif text-lg leading-snug text-navy-900" data-id="element-337" data-mp="45nl1ek77rls">
                  {item.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-slateink-600" data-id="element-338" data-mp="25zemyi0epls1">
                  {item.body}
                </p>
              </article>)}
          </div>
        </div>
      </section>

      <SectionNav currentIndex="06" data-id="element-339" data-mp="dx26c01thige" />
    </>;
}